import { isNullish } from 'remeda';

import { RewardModel } from 'v2/types/RewardModel';
import { VideoModel } from 'v2/types/VideoModel';

export function mapDTOtoForm(video: VideoModel, reward?: RewardModel) {
  if (isNullish(reward)) {
    return null;
  }

  return {
    name: video.name,
    category: video.category,
    secondsToReward: video.secondsToReward,
    link: video.link,
    previewId: video.previewId,
    rewardType: reward.type,
    rewardValue: reward.value,
  };
}
